import clsx from 'clsx';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertLabel from 'components/HubertUI/HubertLabel';
import HubertPopover from 'components/HubertUI/HubertPopover';
import { Info } from 'lucide-react';
import { type EFormType, FormTypesList } from '@hubertai/screening-question-types';
import { useQuestionEditorContext } from '../../context/create-question.context';
import { Tooltip } from '@radix-ui/themes';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionInTemplateEditAndUneditable, selectQuestionLanguage } from 'rtk/questionEditorSelector';
import { addForm } from 'rtk/Question.Editor.Slice';
import { useTranslation } from 'react-i18next';

const CreateFormHeader = ({ ...props }) => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const inTemplateEditAndUneditable = useAppSelector((state) =>
    selectQuestionInTemplateEditAndUneditable(state, questionId),
  );

  return (
    <div {...props} className={clsx('flex flex-row items-center justify-between gap-2', 'w-full', 'px-2')}>
      <div className="flex flex-row items-center justify-start gap-2">
        <Tooltip content={t('form.header.editTooltip')}>
          <Info className="ml-1 text-gray-400" />
        </Tooltip>
        <HubertLabel>{t('form.header.label')}</HubertLabel>
      </div>

      {!inTemplateEditAndUneditable ? (
        <HubertPopover>
          <HubertPopover.Trigger asChild>
            <HubertButton size={'xs'}>{t('form.header.addButton')}</HubertButton>
          </HubertPopover.Trigger>
          <HubertPopover.Content portalContent={false}>
            {FormTypesList.map((x, index) => {
              return (
                <div
                  key={`create-form-element-${index}`}
                  className={clsx('hover:bg-neutral-purple', 'px-4 py-2', 'cursor-pointer', 'rounded-md')}
                  onClick={() => {
                    dispatch(addForm({ questionId, formType: x as EFormType, language: questionLanguage }));
                  }}
                >
                  {x}
                </div>
              );
            })}
          </HubertPopover.Content>
        </HubertPopover>
      ) : null}
    </div>
  );
};

export default CreateFormHeader;
